module.exports = __webpack_public_path__ + "media/flappy-goal.d83b86f8.mp4";